webpackJsonp([35783957827783],{

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Jump = factory());
	}(this, (function () { 'use strict';
	
	// Robert Penner's easeInOutQuad
	
	// find the rest of his easing functions here: http://robertpenner.com/easing/
	// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js
	
	var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
	  t /= d / 2;
	  if (t < 1) return c / 2 * t * t + b;
	  t--;
	  return -c / 2 * (t * (t - 2) - 1) + b;
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var jumper = function jumper() {
	  // private variable cache
	  // no variables are created during a jump, preventing memory leaks
	
	  var element = void 0; // element to scroll to                   (node)
	
	  var start = void 0; // where scroll starts                    (px)
	  var stop = void 0; // where scroll stops                     (px)
	
	  var offset = void 0; // adjustment from the stop position      (px)
	  var easing = void 0; // easing function                        (function)
	  var a11y = void 0; // accessibility support flag             (boolean)
	
	  var distance = void 0; // distance of scroll                     (px)
	  var duration = void 0; // scroll duration                        (ms)
	
	  var timeStart = void 0; // time scroll started                    (ms)
	  var timeElapsed = void 0; // time spent scrolling thus far          (ms)
	
	  var next = void 0; // next scroll position                   (px)
	
	  var callback = void 0; // to call when done scrolling            (function)
	
	  // scroll position helper
	
	  function location() {
	    return window.scrollY || window.pageYOffset;
	  }
	
	  // element offset helper
	
	  function top(element) {
	    return element.getBoundingClientRect().top + start;
	  }
	
	  // rAF loop helper
	
	  function loop(timeCurrent) {
	    // store time scroll started, if not started already
	    if (!timeStart) {
	      timeStart = timeCurrent;
	    }
	
	    // determine time spent scrolling so far
	    timeElapsed = timeCurrent - timeStart;
	
	    // calculate next scroll position
	    next = easing(timeElapsed, start, distance, duration);
	
	    // scroll to it
	    window.scrollTo(0, next);
	
	    // check progress
	    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
	    : done(); // scrolling is done
	  }
	
	  // scroll finished helper
	
	  function done() {
	    // account for rAF time rounding inaccuracies
	    window.scrollTo(0, start + distance);
	
	    // if scrolling to an element, and accessibility is enabled
	    if (element && a11y) {
	      // add tabindex indicating programmatic focus
	      element.setAttribute('tabindex', '-1');
	
	      // focus the element
	      element.focus();
	    }
	
	    // if it exists, fire the callback
	    if (typeof callback === 'function') {
	      callback();
	    }
	
	    // reset time for next jump
	    timeStart = false;
	  }
	
	  // API
	
	  function jump(target) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // resolve options, or use defaults
	    duration = options.duration || 1000;
	    offset = options.offset || 0;
	    callback = options.callback; // "undefined" is a suitable default, and won't be called
	    easing = options.easing || easeInOutQuad;
	    a11y = options.a11y || false;
	
	    // cache starting position
	    start = location();
	
	    // resolve target
	    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
	      // scroll from current position
	      case 'number':
	        element = undefined; // no element to scroll to
	        a11y = false; // make sure accessibility is off
	        stop = start + target;
	        break;
	
	      // scroll to element (node)
	      // bounding rect is relative to the viewport
	      case 'object':
	        element = target;
	        stop = top(element);
	        break;
	
	      // scroll to element (selector)
	      // bounding rect is relative to the viewport
	      case 'string':
	        element = document.querySelector(target);
	        stop = top(element);
	        break;
	    }
	
	    // resolve scroll distance, accounting for offset
	    distance = stop - start + offset;
	
	    // resolve duration
	    switch (_typeof(options.duration)) {
	      // number in ms
	      case 'number':
	        duration = options.duration;
	        break;
	
	      // function passed the distance of the scroll
	      case 'function':
	        duration = options.duration(distance);
	        break;
	    }
	
	    // start the loop
	    window.requestAnimationFrame(loop);
	  }
	
	  // expose only the jump method
	  return jump;
	};
	
	// export singleton
	
	var singleton = jumper();
	
	return singleton;
	
	})));


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollIndicator = __webpack_require__(140);
	
	var _ScrollIndicator2 = _interopRequireDefault(_ScrollIndicator);
	
	var _RectButton = __webpack_require__(78);
	
	var _RectButton2 = _interopRequireDefault(_RectButton);
	
	var _IntroWithButtonModule = __webpack_require__(88);
	
	var _IntroWithButtonModule2 = _interopRequireDefault(_IntroWithButtonModule);
	
	var _gsap = __webpack_require__(11);
	
	var _CSSPlugin = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	var SplitText = void 0;
	
	var IntroWithButton = function (_Component) {
	  _inherits(IntroWithButton, _Component);
	
	  function IntroWithButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IntroWithButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.splitTextRun = false, _this.setThemeClass = function (color) {
	      switch (color) {
	        case 'blue':
	          return 'chapter-theme--blue';
	        case 'yellow':
	          return 'chapter-theme--yellow';
	        case 'green':
	          return 'chapter-theme--green';
	        default:
	          return 'chapter-theme--red';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IntroWithButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      SplitText = __webpack_require__(144);
	    }
	    if (this.props.startHidden && this.props.show) {
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	
	    this.runSplitText();
	
	    var header = this.wrapper.querySelectorAll('.maskDownTitle');
	    var subHeader = this.wrapper.querySelector('p');
	    var button = this.wrapper.querySelector('.js-introButton');
	    var kicker = this.wrapper.querySelector('h5');
	    var rule = this.wrapper.querySelector('.ch-inner-rule');
	    if (this.props.startHidden && !this.props.show) {
	      // console.log('transitioning, so hide slider text');
	      header && _gsap.TweenLite.set(header, { y: '100%' });
	      subHeader && _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      button && _gsap.TweenLite.set(button, { y: '100%' });
	      kicker && _gsap.TweenLite.set(kicker, { y: '100%' });
	      rule && _gsap.TweenLite.set(rule, { scaleX: 0 });
	      this.scrollIndicator && _gsap.TweenLite.set(this.scrollIndicator, { opacity: 0, y: 20 });
	    }
	  };
	
	  IntroWithButton.prototype.runSplitText = function runSplitText() {
	    // console.log(this.props.title, 'try to run splittext');
	    if (!this.props.doSplitText || this.splitTextRun) {
	      // console.log(this.props.title, 'already run, dont');
	      return;
	    }
	    // console.log(this.props.title, 'actually run it');
	    this.splitTextRun = true;
	
	    var splitWords = void 0;
	    var splitTarget = this.wrapper.querySelector('h1');
	    var splitText = new SplitText(splitTarget, {
	      type: 'words',
	      wordsClass: 'maskDownTitle'
	    });
	
	    if (typeof document !== 'undefined') {
	      splitWords = splitTarget.querySelectorAll('.maskDownTitle');
	    }
	    var wrap = function wrap(el, wrapper) {
	      el.parentNode.insertBefore(wrapper, el);
	      wrapper.appendChild(el);
	    };
	
	    splitWords.forEach(function (word) {
	      var element = void 0;
	      if (typeof document !== 'undefined') {
	        element = document.createElement('div');
	      }
	      element.className = _IntroWithButtonModule2.default.maskDownWrapper;
	      wrap(word, element);
	    });
	  };
	
	  IntroWithButton.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // if text Changes, have to run split text again
	    if (this.props.title !== prevProps.title || this.props.subtitle !== prevProps.subtitle) {
	      // console.log('text change hide text and run split text');
	      this.splitTextRun = false;
	      this.runSplitText();
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	      // if (this.props.textTransitioning ) {
	      // console.log('transitioning, so hide slider text');
	      _gsap.TweenLite.set(header, { y: '100%' });
	      _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      _gsap.TweenLite.set(button, { y: '100%' });
	      _gsap.TweenLite.set(kicker, { y: '100%' });
	      _gsap.TweenLite.set(rule, { scaleX: 0 });
	      // }
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	  };
	
	  IntroWithButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // FPO enter and exit animations for this element
	
	    if (this.props.startHidden && !this.props.show && nextProps.show) {
	      // run split text before show
	      this.runSplitText();
	      // show
	      // TweenLite.to(this.wrapper, 0.5, { opacity: 1 });
	
	      // console.log('reveal text on change of show prop, nextProps.show true');
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	
	      var duration = 0.78;
	      var increment = 0.2;
	      var delay = 0.0;
	
	      var tl = new _gsap.TimelineLite();
	      if (kicker) {
	        tl.to(kicker, duration, {
	          y: '0%',
	          ease: Quad.easeInOut
	        }, delay += increment);
	      }
	
	      rule && tl.to(rule, duration, {
	        scaleX: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      header && tl.to(header, duration, {
	        y: '0%',
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      subHeader && tl.to(subHeader, duration, {
	        y: '0%',
	        autoAlpha: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      button && tl.to(button, duration, {
	        y: '0%',
	        ease: Quad.easeOut
	      }, delay);
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, duration, {
	        opacity: 1,
	        y: 0,
	        delay: 0.5
	      });
	    }
	    if (this.props.startHidden && this.props.show && !nextProps.show) {
	      // hide
	      // console.log('hide text when next props show is false');
	      var _header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var _subHeader = this.wrapper.querySelector('p');
	      var _button = this.wrapper.querySelector('.js-introButton');
	      var _kicker = this.wrapper.querySelector('h5');
	      var _rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      var _duration = 0.6;
	      var _increment = 0.0;
	      var _delay = 0.0;
	
	      {
	        _kicker && _gsap.TweenLite.to(_kicker, _duration, {
	          y: '100%',
	          ease: Quad.easeIn,
	          delay: _delay,
	          onComplete: function onComplete() {
	            _gsap.TweenLite.set(_this2.wrapper, { opacity: 0 });
	          }
	        });
	        _delay += _increment;
	      }
	
	      _rule && _gsap.TweenLite.to(_rule, _duration * 0.5, {
	        scaleX: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _header && _gsap.TweenLite.to(_header, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _subHeader && _gsap.TweenLite.to(_subHeader, _duration, {
	        y: '10%',
	        autoAlpha: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _button && _gsap.TweenLite.to(_button, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, _duration, {
	        opacity: 0,
	        y: 20,
	        delay: 0.5
	      });
	    }
	
	    // text back on after chapter transition
	    if (this.props.textExit && !nextProps.textExit) {
	      // console.log('set text back on false textExit prop');
	      var resetElements = [this.wrapper.querySelector('h1'), this.wrapper.querySelector('p'), this.wrapper.querySelector('.js-introButton'), this.wrapper.querySelector('h5')];
	      resetElements.forEach(function (el) {
	        if (el) {
	          el.removeAttribute('style');
	        }
	      });
	    }
	    // text animate off for chapter click
	    if (!this.props.textExit && nextProps.textExit) {
	      // console.log('textExit so hide');
	      // chapter exit text animation
	      var _header2 = this.wrapper.querySelector('h1');
	      var _subHeader2 = this.wrapper.querySelector('p');
	      var _button2 = this.wrapper.querySelector('.js-introButton');
	      var _kicker2 = this.wrapper.querySelector('h5');
	
	      var _tl = new _gsap.TimelineLite();
	      if (_kicker2) {
	        _gsap.TweenLite.to(_kicker2, 0.8, {
	          css: {
	            color: '#FFFFFF'
	          },
	          ease: Circ.easeInOut
	        });
	      }
	
	      _tl.to(_subHeader2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }).to(_button2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }, '-=' + 0.8).to(_header2, 0.8, {
	        css: {
	          color: '#FFFFFF'
	        },
	        ease: Circ.easeInOut
	      }, '-=' + 0.8);
	    }
	  };
	
	  IntroWithButton.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        path = _props.path,
	        kicker = _props.kicker,
	        buttonText = _props.buttonText,
	        subtitle = _props.subtitle,
	        colorTheme = _props.colorTheme,
	        scrollIndicator = _props.scrollIndicator,
	        handleClick = _props.handleClick,
	        textWhite = _props.textWhite,
	        noPad = _props.noPad,
	        scrollClass = _props.scrollClass,
	        scrollOffset = _props.scrollOffset,
	        buttonCTA = _props.buttonCTA,
	        index = _props.index,
	        startHidden = _props.startHidden,
	        noMobileRule = _props.noMobileRule,
	        noButton = _props.noButton;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: function ref(el) {
	          _this3.wrapper = el;
	        }
	        // chapter-info
	        , className: 'intro-text ' + _IntroWithButtonModule2.default.infoWrapper + ' ' + this.setThemeClass(colorTheme) + ' ' + (textWhite ? _IntroWithButtonModule2.default.textWhite : '') + ' ' + (noPad ? _IntroWithButtonModule2.default.noPad : '') + ' ' + (startHidden ? _IntroWithButtonModule2.default.startHidden : '') + ' ' + (noMobileRule ? _IntroWithButtonModule2.default.noMobileRule : '')
	      },
	      kicker && _react2.default.createElement(
	        'div',
	        { className: _IntroWithButtonModule2.default.maskWrap },
	        _react2.default.createElement(
	          'h5',
	          null,
	          kicker
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: '' + _IntroWithButtonModule2.default.innerWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.ruleMask },
	          _react2.default.createElement('span', {
	            style: { transformOrigin: '0 50%' },
	            className: 'ch-inner-rule ' + _IntroWithButtonModule2.default.innerRule
	          })
	        ),
	        title && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.titleWrapper },
	          _react2.default.createElement('h1', {
	            className: 'splitText-' + index,
	            dangerouslySetInnerHTML: { __html: title }
	          })
	        ),
	        subtitle && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.subtitleWrap },
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: subtitle } })
	        ),
	        path && !noButton && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap },
	          _react2.default.createElement(
	            'div',
	            { className: 'js-introButton' },
	            _react2.default.createElement(_RectButton2.default, {
	              path: path,
	              buttonText: buttonText ? buttonText : 'Explore',
	              handleClick: handleClick
	            })
	          )
	        ),
	        scrollIndicator && _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(el) {
	              _this3.scrollIndicator = el;
	            }
	          },
	          _react2.default.createElement(_ScrollIndicator2.default, {
	            scrollClass: scrollClass,
	            scrollOffset: scrollOffset
	          })
	        )
	      )
	    );
	  };
	
	  return IntroWithButton;
	}(_react.Component);
	
	exports.default = IntroWithButton;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"innerRule":"src-components-global----IntroWithButton-module---innerRule---2uz3M","ruleMask":"src-components-global----IntroWithButton-module---ruleMask---I10EJ","noMobileRule":"src-components-global----IntroWithButton-module---noMobileRule---1FH7b","infoWrapper":"src-components-global----IntroWithButton-module---infoWrapper---28Q5L","noPad":"src-components-global----IntroWithButton-module---noPad---uRpVp","textWhite":"src-components-global----IntroWithButton-module---textWhite---1n0fg","startHidden":"src-components-global----IntroWithButton-module---startHidden---3Ik6w","maskDownWrapper":"src-components-global----IntroWithButton-module---maskDownWrapper---1CE5R","subtitleWrap":"src-components-global----IntroWithButton-module---subtitleWrap---3V1MX","maskWrap":"src-components-global----IntroWithButton-module---maskWrap---3ssr6","fadeIn":"src-components-global----IntroWithButton-module---fadeIn---En3ul","fadeInUp":"src-components-global----IntroWithButton-module---fadeInUp---2543W","fadeInUpCenter":"src-components-global----IntroWithButton-module---fadeInUpCenter---1wd9t","fadeInUpSmall":"src-components-global----IntroWithButton-module---fadeInUpSmall---uMzc-","textCoverIn":"src-components-global----IntroWithButton-module---textCoverIn---2WfKk","textCoverOut":"src-components-global----IntroWithButton-module---textCoverOut---38T8k"};

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _CSSPlugin = __webpack_require__(47);
	
	var _PlayPauseButton = __webpack_require__(71);
	
	var _PlayPauseButton2 = _interopRequireDefault(_PlayPauseButton);
	
	var _AutoAdvancerModule = __webpack_require__(404);
	
	var _AutoAdvancerModule2 = _interopRequireDefault(_AutoAdvancerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	
	var AutoAdvancer = function (_Component) {
	  _inherits(AutoAdvancer, _Component);
	
	  function AutoAdvancer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutoAdvancer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isPlaying: true
	    }, _this.renderDots = function (totalSlides, currentSlide) {
	      var dots = [];
	
	      var _loop = function _loop(index) {
	        dots.push(_react2.default.createElement(
	          'div',
	          {
	            id: 'dot-' + index,
	            key: 'dot-' + index,
	            className: _AutoAdvancerModule2.default.dot + ' ' + (currentSlide === index && !_this.props.isTransitioning ? _AutoAdvancerModule2.default.active : ''),
	            onClick: function onClick() {
	              _this.props.anySlide(index);
	            }
	          },
	          _react2.default.createElement('div', { className: _AutoAdvancerModule2.default.outerDot }),
	          _react2.default.createElement('div', { className: _AutoAdvancerModule2.default.innerDot })
	        ));
	      };
	
	      for (var index = 0; index < totalSlides; index++) {
	        _loop(index);
	      }
	      return dots;
	    }, _this.createAnimation = function (foreground) {
	      if (_this.tween) return;
	
	      _this.foregroundRef = foreground;
	
	      _gsap.TweenLite.set(foreground, { scaleX: 0 });
	
	      _this.tween = _gsap.TweenLite.to(foreground, 14, {
	        scaleX: 1,
	        paused: true,
	        onComplete: function onComplete() {
	          _this.props.currentIndex === _this.props.totalSlides - 1 ? _this.props.anySlide(0) : _this.props.nextSlide();
	          _this.pause(true);
	        },
	        ease: _gsap.Linear.easeNone
	      });
	
	      if (!_this.props.waitingForLoad) _this.play(true);
	    }, _this.play = function () {
	      var restart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      _this.setState({
	        isPlaying: true
	      }, function () {
	        return restart ? _this.tween.play(0) : _this.tween.play();
	      });
	    }, _this.pause = function () {
	      var restart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      _this.setState({
	        isPlaying: false
	      }, function () {
	        return restart ? _this.tween.pause(0) : _this.tween.pause();
	      });
	    }, _this.handlePlayPause = function () {
	      return _this.state.isPlaying ? _this.pause() : _this.play();
	    }, _this.handleKeypress = function (e) {
	      if (e.keyCode == 32) {
	        if (_this.state.isPlaying) {
	          _this.pause();
	        } else {
	          _this.play();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AutoAdvancer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.currentIndex !== prevProps.currentIndex) {
	      this.play(true);
	    }
	    if (this.props.waitingForLoad !== prevProps.waitingForLoad && !this.props.waitingForLoad) {
	      this.play(true);
	    }
	  };
	
	  AutoAdvancer.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('keydown', this.handleKeypress);
	    if (this.props.registerPause) {
	      this.props.registerPause(this.pause);
	    }
	  };
	
	  AutoAdvancer.prototype.componentWillUnmount = function componentWillUnmount() {
	    _gsap.TweenLite.killTweensOf(this.foregroundRef);
	    if (this.tween && this.tween.kill) {
	      this.tween.kill();
	    }
	    window.removeEventListener('keypress', this.handleKeypress);
	  };
	  // Pause on spacebar press... I found myself trying to do this subconciously
	
	
	  AutoAdvancer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _AutoAdvancerModule2.default.container + ' ' + (this.props.exited ? _AutoAdvancerModule2.default.exited : '')
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _AutoAdvancerModule2.default.dotContainer },
	        this.renderDots(this.props.totalSlides, this.props.currentIndex)
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (this.props.isHome ? _AutoAdvancerModule2.default.isHome : '') + ' ' + _AutoAdvancerModule2.default.buttonContainer
	        },
	        _react2.default.createElement(_PlayPauseButton2.default, {
	          noBackground: true,
	          colorTheme: this.props.colorTheme,
	          isPaused: !this.state.isPlaying,
	          onPlayPauseClick: this.state.isPlaying ? this.pause.bind(null, false) : this.play.bind(null, false)
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AutoAdvancerModule2.default.progressBar },
	        _react2.default.createElement('div', { className: _AutoAdvancerModule2.default.background }),
	        _react2.default.createElement('div', {
	          className: _AutoAdvancerModule2.default.foreground + ' ' + _AutoAdvancerModule2.default['color-' + this.props.colorTheme],
	          ref: this.createAnimation
	        })
	      )
	    );
	  };
	
	  return AutoAdvancer;
	}(_react.Component);
	
	exports.default = AutoAdvancer;
	module.exports = exports['default'];

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-ui----AutoAdvancer-module---container---390tq","exited":"src-components-ui----AutoAdvancer-module---exited---ZTuP9","progressBar":"src-components-ui----AutoAdvancer-module---progressBar---2yfyc","background":"src-components-ui----AutoAdvancer-module---background---gDEEQ","foreground":"src-components-ui----AutoAdvancer-module---foreground---37Boy","color-red":"src-components-ui----AutoAdvancer-module---color-red---139q3","color-blue":"src-components-ui----AutoAdvancer-module---color-blue---2wxgk","color-yellow":"src-components-ui----AutoAdvancer-module---color-yellow---fW8Xn","color-green":"src-components-ui----AutoAdvancer-module---color-green---4XnyE","dotContainer":"src-components-ui----AutoAdvancer-module---dotContainer---kHjYS","dot":"src-components-ui----AutoAdvancer-module---dot---26mQO","active":"src-components-ui----AutoAdvancer-module---active---1GHwd","outerDot":"src-components-ui----AutoAdvancer-module---outerDot---1lR3l","innerDot":"src-components-ui----AutoAdvancer-module---innerDot---d2AHG","buttonContainer":"src-components-ui----AutoAdvancer-module---buttonContainer---7Udbk","isHome":"src-components-ui----AutoAdvancer-module---isHome---2iKlM","fadeIn":"src-components-ui----AutoAdvancer-module---fadeIn---Wzvdl","fadeInUp":"src-components-ui----AutoAdvancer-module---fadeInUp---_4hW7","fadeInUpCenter":"src-components-ui----AutoAdvancer-module---fadeInUpCenter---3i-a7","fadeInUpSmall":"src-components-ui----AutoAdvancer-module---fadeInUpSmall---5n4KK","textCoverIn":"src-components-ui----AutoAdvancer-module---textCoverIn---1dZIB","textCoverOut":"src-components-ui----AutoAdvancer-module---textCoverOut---2yhmJ"};

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(181);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _CarouselSlide = __webpack_require__(556);
	
	var _CarouselSlide2 = _interopRequireDefault(_CarouselSlide);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _AutoAdvancer = __webpack_require__(350);
	
	var _AutoAdvancer2 = _interopRequireDefault(_AutoAdvancer);
	
	var _SwipeNextPrev = __webpack_require__(141);
	
	var _SwipeNextPrev2 = _interopRequireDefault(_SwipeNextPrev);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Carousel = function (_Component) {
	  _inherits(Carousel, _Component);
	
	  function Carousel() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      animating: false,
	      currentIndex: 0
	    }, _this.slickOptions = {
	      dots: false,
	      infinite: false,
	      draggable: false,
	      speed: 1500,
	      touchMove: false, //these all
	      swipeToSlide: false, // seem
	      swipe: false, // the same
	      cssEase: 'cubic-bezier(.9, 0, .3, 1)',
	      nextArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'right', white: true }),
	      prevArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'left', white: true }),
	      beforeChange: function beforeChange(oldIndex, newIndex) {
	        // apparently oldindex doesn't work
	        if (_this.state.currentIndex !== newIndex) {
	          _this.setState({ animating: true });
	        }
	      },
	      afterChange: function afterChange(index) {
	        _this.setState({
	          animating: false,
	          currentIndex: index
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Carousel.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_SwipeNextPrev2.default, {
	        next: this.slider && this.slider.slickNext,
	        prev: this.slider && this.slider.slickPrev
	      }),
	      _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({
	          className: 'slick slick-full arrow-bottom home-slick',
	          ref: function ref(el) {
	            return _this2.slider = el;
	          }
	        }, this.slickOptions),
	        this.props.slideData.map(function (slideNode, i) {
	          var slide = slideNode.node;
	          return _react2.default.createElement(
	            'div',
	            { key: 'slide' + i },
	            _react2.default.createElement(_CarouselSlide2.default, {
	              color_theme: 'red',
	              title: slide.home_headline,
	              subtitle: slide.home_body,
	              image: slide.home_image.sizes.large,
	              path: slide.path,
	              buttonCTA: slide.home_cta_text,
	              index: i,
	              waitingForLoad: _this2.props.introIsShowing,
	              currentIndex: _this2.state.currentIndex,
	              animating: _this2.state.animating,
	              revealText: _this2.props.revealText
	            })
	          );
	        })
	      ),
	      this.slider && _react2.default.createElement(_AutoAdvancer2.default, {
	        colorTheme: 'red',
	        isTransitioning: this.state.animating,
	        nextSlide: this.slider.slickNext,
	        anySlide: this.slider.slickGoTo,
	        totalSlides: this.props.slideData.length,
	        currentIndex: this.state.currentIndex,
	        isHome: true,
	        exited: this.props.introIsShowing,
	        waitingForLoad: this.props.introIsShowing
	      })
	    );
	  };
	
	  return Carousel;
	}(_react.Component);
	
	exports.default = Carousel;
	module.exports = exports['default'];

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IntroWithButton = __webpack_require__(82);
	
	var _IntroWithButton2 = _interopRequireDefault(_IntroWithButton);
	
	var _CarouselSlideModule = __webpack_require__(863);
	
	var _CarouselSlideModule2 = _interopRequireDefault(_CarouselSlideModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselSlide = function CarouselSlide(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _CarouselSlideModule2.default.slideWrap },
	    _react2.default.createElement('div', {
	      className: 'slide-image ' + _CarouselSlideModule2.default.slideImage,
	      style: { backgroundImage: 'url(' + props.image + ')' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _CarouselSlideModule2.default.slideText },
	      _react2.default.createElement(_IntroWithButton2.default, {
	        title: props.title,
	        path: !props.buttonCTA ? null : props.path,
	        subtitle: props.subtitle,
	        colorTheme: props.color_theme,
	        buttonText: props.buttonCTA,
	        noButton: !props.buttonCTA,
	        textWhite: true,
	        noPad: true,
	        startHidden: true,
	        noMobileRule: true,
	        show: !props.waitingForLoad && props.index === props.currentIndex && !props.animating && props.revealText,
	        doSplitText: true,
	        index: 'carousel' + props.index
	      })
	    )
	  );
	};
	
	exports.default = CarouselSlide;
	module.exports = exports['default'];

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slideWrap":"src-components-ui----CarouselSlide-module---slideWrap---DPOSn","slideImage":"src-components-ui----CarouselSlide-module---slideImage---2xSGw","slideText":"src-components-ui----CarouselSlide-module---slideText---YUqp-","fadeIn":"src-components-ui----CarouselSlide-module---fadeIn---pE1BT","fadeInUp":"src-components-ui----CarouselSlide-module---fadeInUp---3EO3p","fadeInUpCenter":"src-components-ui----CarouselSlide-module---fadeInUpCenter---ezCVa","fadeInUpSmall":"src-components-ui----CarouselSlide-module---fadeInUpSmall---200t7","textCoverIn":"src-components-ui----CarouselSlide-module---textCoverIn---1xcus","textCoverOut":"src-components-ui----CarouselSlide-module---textCoverOut---3tX1F"};

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroContainerModule = __webpack_require__(864);
	
	var _HeroContainerModule2 = _interopRequireDefault(_HeroContainerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroContainer = function HeroContainer(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _HeroContainerModule2.default.heroContainer + ' ' + (props.top ? _HeroContainerModule2.default.top : '') + ' ' + (props.exiting ? _HeroContainerModule2.default.exiting : '')
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _HeroContainerModule2.default.heroWrap },
	      props.children
	    )
	  );
	};
	
	exports.default = HeroContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heroContainer":"src-components-ui----HeroContainer-module---heroContainer---2GaTV","heroWrap":"src-components-ui----HeroContainer-module---heroWrap---3-1x4","fadeIn":"src-components-ui----HeroContainer-module---fadeIn---2b7gv","top":"src-components-ui----HeroContainer-module---top---xillK","exiting":"src-components-ui----HeroContainer-module---exiting---1E4Et","fadeInUp":"src-components-ui----HeroContainer-module---fadeInUp---2Ragy","fadeInUpCenter":"src-components-ui----HeroContainer-module---fadeInUpCenter---2_LsZ","fadeInUpSmall":"src-components-ui----HeroContainer-module---fadeInUpSmall---dQu6C","textCoverIn":"src-components-ui----HeroContainer-module---textCoverIn---2p-KG","textCoverOut":"src-components-ui----HeroContainer-module---textCoverOut---3zJo9"};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _PlayPauseButtonModule = __webpack_require__(157);
	
	var _PlayPauseButtonModule2 = _interopRequireDefault(_PlayPauseButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MorphSVG = void 0;
	
	var PlayPauseButton = function (_Component) {
	  _inherits(PlayPauseButton, _Component);
	
	  function PlayPauseButton() {
	    _classCallCheck(this, PlayPauseButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlayPauseButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      MorphSVG = __webpack_require__(143);
	    }
	
	    // Play/Pause button animation
	    this.playPauseAnim = new TimelineMax({
	      paused: true
	    });
	
	    this.playPauseAnim.to(this.playPauseLeft, 0.3, {
	      x: 2.2,
	      morphSVG: '7.5,12.9 7.5,12.9 0,17 0,8.5 0,0 7.5,4.2 7.5,4.2 7.5,8.5',
	      ease: Cubic.easeInOut
	    }).to(this.playPauseRight, 0.3, {
	      x: 2,
	      morphSVG: '15,8.5 7.5,12.9 7.5,12.9 7.5,8.5 7.5,4.2 7.5,4.2 15,8.5 15,8.5',
	      ease: Cubic.easeInOut
	    }, '-=0.3');
	
	    if (this.props.isVideoPaused || this.props.isAudioPaused || this.props.isPaused) {
	      this.playPauseAnim.progress(1);
	    }
	  };
	
	  PlayPauseButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // Play/Pause Button Animation
	    if (this.props.isVideoPaused !== nextProps.isVideoPaused || this.props.isAudioPaused !== nextProps.isAudioPaused || this.props.isPaused !== nextProps.isPaused) {
	      if (nextProps.isVideoPaused || nextProps.isAudioPaused || nextProps.isPaused) {
	        this.playPauseAnim.play();
	      } else {
	        this.playPauseAnim.reverse();
	      }
	    }
	  };
	
	  PlayPauseButton.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'play-pause-button ' + _PlayPauseButtonModule2.default.playPauseButton + ' ' + (!this.props.noBorder ? _PlayPauseButtonModule2.default.playPauseBorder : '') + ' ' + (!this.props.noBackground ? 'play-pause-bg ' + _PlayPauseButtonModule2.default.playPauseBackground : '') + ' ' + (this.props.largeButton ? _PlayPauseButtonModule2.default.playPauseLarge : '') + ' ' + (this.props.colorTheme ? _PlayPauseButtonModule2.default['color-' + this.props.colorTheme] : ''),
	        onClick: this.props.onPlayPauseClick
	      },
	      _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '15',
	          height: '17',
	          viewBox: '0 0 15 17',
	          overflow: 'visible'
	        },
	        _react2.default.createElement(
	          'title',
	          null,
	          'Play/Pause Button'
	        ),
	        _react2.default.createElement('polygon', {
	          ref: function ref(el) {
	            return _this2.playPauseLeft = el;
	          },
	          points: '5,17 2.5,17 0,17 0,8.5 0,0 2.5,0 5,0 5,8.5 '
	        }),
	        _react2.default.createElement('polygon', {
	          ref: function ref(el) {
	            return _this2.playPauseRight = el;
	          },
	          points: '15,17 12.5,17 10,17 10,8.5 10,0 12.5,0 15,0 15,8.5 '
	        }),
	        !this.props.noBorder && _react2.default.createElement('circle', {
	          stroke: 'white',
	          strokeWidth: '2',
	          fill: 'none',
	          cx: '50%',
	          cy: '50%',
	          r: '135%'
	        })
	      )
	    );
	  };
	
	  return PlayPauseButton;
	}(_react.Component);
	
	exports.default = PlayPauseButton;
	module.exports = exports['default'];

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"playPauseButton":"src-components-ui----PlayPauseButton-module---playPauseButton---2kFGi","playPauseBackground":"src-components-ui----PlayPauseButton-module---playPauseBackground---1IcCm","playPauseLarge":"src-components-ui----PlayPauseButton-module---playPauseLarge---z_qtV","color-red":"src-components-ui----PlayPauseButton-module---color-red---3PlYW","color-blue":"src-components-ui----PlayPauseButton-module---color-blue---YFr-B","color-yellow":"src-components-ui----PlayPauseButton-module---color-yellow---3oOaE","color-green":"src-components-ui----PlayPauseButton-module---color-green---2Ugyl","fadeIn":"src-components-ui----PlayPauseButton-module---fadeIn---hJgSk","fadeInUp":"src-components-ui----PlayPauseButton-module---fadeInUp---CFhFT","fadeInUpCenter":"src-components-ui----PlayPauseButton-module---fadeInUpCenter---2NweF","fadeInUpSmall":"src-components-ui----PlayPauseButton-module---fadeInUpSmall---1m3jW","textCoverIn":"src-components-ui----PlayPauseButton-module---textCoverIn---1P0rg","textCoverOut":"src-components-ui----PlayPauseButton-module---textCoverOut---2o-vA"};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RectButtonModule = __webpack_require__(158);
	
	var _RectButtonModule2 = _interopRequireDefault(_RectButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// if path is passed, renders a link (which can also take a click handler)
	// If no path, it renders a button
	var RectButton = function RectButton(_ref) {
	  var path = _ref.path,
	      buttonText = _ref.buttonText,
	      externalLink = _ref.externalLink,
	      handleClick = _ref.handleClick;
	  return path ? _react2.default.createElement(
	    'a',
	    {
	      href: path,
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      target: externalLink ? '_blank' : '',
	      rel: externalLink ? 'noopener' : '',
	      onClick: handleClick ? handleClick : function () {}
	    },
	    buttonText
	  ) : _react2.default.createElement(
	    'button',
	    {
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      onClick: handleClick
	    },
	    buttonText
	  );
	};
	
	exports.default = RectButton;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rectButton":"src-components-ui----RectButton-module---rectButton---kOGDP","fadeIn":"src-components-ui----RectButton-module---fadeIn---2i_MH","fadeInUp":"src-components-ui----RectButton-module---fadeInUp---1Klsv","fadeInUpCenter":"src-components-ui----RectButton-module---fadeInUpCenter---24B-G","fadeInUpSmall":"src-components-ui----RectButton-module---fadeInUpSmall---2LhD0","textCoverIn":"src-components-ui----RectButton-module---textCoverIn---1AHwq","textCoverOut":"src-components-ui----RectButton-module---textCoverOut---2lqeu"};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jump = __webpack_require__(81);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _ScrollIndicatorModule = __webpack_require__(159);
	
	var _ScrollIndicatorModule2 = _interopRequireDefault(_ScrollIndicatorModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Smooth scroll to content start
	var scrollClick = function scrollClick(scrollClass, scrollOffset) {
	  (0, _jump2.default)(scrollClass, {
	    offset: scrollOffset
	  });
	};
	
	var ScrollIndicator = function ScrollIndicator(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _ScrollIndicatorModule2.default.scrollIndicator,
	      onClick: function onClick() {
	        scrollClick(props.scrollClass, props.scrollOffset);
	      }
	    },
	    _react2.default.createElement(_ArrowButton2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: _ScrollIndicatorModule2.default.scrollText },
	      'Scroll'
	    )
	  );
	};
	
	exports.default = ScrollIndicator;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scrollIndicator":"src-components-ui----ScrollIndicator-module---scrollIndicator---3-hD6","scrollText":"src-components-ui----ScrollIndicator-module---scrollText---7KuIx","fadeIn":"src-components-ui----ScrollIndicator-module---fadeIn---2RGcS","fadeInUp":"src-components-ui----ScrollIndicator-module---fadeInUp---XKTTZ","fadeInUpCenter":"src-components-ui----ScrollIndicator-module---fadeInUpCenter---2JaVr","fadeInUpSmall":"src-components-ui----ScrollIndicator-module---fadeInUpSmall---10Khg","textCoverIn":"src-components-ui----ScrollIndicator-module---textCoverIn---MwX7O","textCoverOut":"src-components-ui----ScrollIndicator-module---textCoverOut---1_0em"};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeListener = __webpack_require__(145);
	
	var _swipeListener2 = _interopRequireDefault(_swipeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var minXSwipe = 50;
	
	var SwipeNextPrev = function (_Component) {
	  _inherits(SwipeNextPrev, _Component);
	
	  function SwipeNextPrev() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SwipeNextPrev);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleSwipeEnd = function () {
	      _this.reset();
	    }, _this.handleSwipe = function (e) {
	      var swipeXCoord = e.detail.x[1];
	      if (!_this.isSwiping) {
	        // start
	        _this.isSwiping = true;
	        _this.start = swipeXCoord;
	      } else {
	        var diff = swipeXCoord - _this.start;
	        if (Math.abs(diff) > minXSwipe && !_this.fired) {
	          _this.fired = true;
	          if (diff > 0) {
	            _this.props.prev();
	          } else {
	            _this.props.next();
	          }
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SwipeNextPrev.prototype.componentDidMount = function componentDidMount() {
	    this.element = this.props.element ? this.props.element : window;
	    this.listener = (0, _swipeListener2.default)(this.element, {
	      // minHorizontal: 50,
	      // minVertical: 50,
	      // deltaHorizontal: 50,
	      lockAxis: true
	    });
	    // element.addEventListener('swipe', this.handleSwipe);
	    this.element.addEventListener('swiping', this.handleSwipe);
	    this.element.addEventListener('swiperelease', this.handleSwipeEnd);
	
	    this.reset();
	  };
	
	  SwipeNextPrev.prototype.reset = function reset() {
	    this.start = 0;
	    this.isSwiping = false;
	    this.fired = false;
	  };
	
	  SwipeNextPrev.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.element.removeEventListener('swiping', this.handleSwipe);
	    this.element.removeEventListener('swiperelease', this.handleSwipeEnd);
	    this.listener.off();
	  };
	
	  SwipeNextPrev.prototype.render = function render() {
	    return null;
	  };
	
	  return SwipeNextPrev;
	}(_react.Component);
	
	exports.default = SwipeNextPrev;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * VERSION: 0.8.11
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * MorphSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
	 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
	 * This work is subject to the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : undefined || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	
		"use strict";
	
		var _DEG2RAD = Math.PI / 180,
		    _RAD2DEG = 180 / Math.PI,
		    _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		    _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		    _selectorExp = /(^[#\.][a-z]|[a-y][a-z])/gi,
		    _commands = /[achlmqstvz]/ig,
		    _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
	
		//_attrExp = /(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi, //finds all the attribute name/value pairs in an HTML element
		//_outerTagExp = /^<([A-Za-z0-9_\-]+)((?:\s+[A-Za-z0-9_\-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/i, //takes the outerHTML and pulls out [0] - the first tag, [1] - the tag name, and [2] - the attribute name/value pairs (space-delimited)
		//_wrappingQuotesExp = /^["']|["']$/g,
		TweenLite = _gsScope._gsDefine.globals.TweenLite,
	
		//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
	
		_log = function _log(message) {
			if (_gsScope.console) {
				console.log(message);
			}
		},
	
	
		// translates an arc into a normalized array of cubic beziers excluding the starting x/y. The circle the arc follows will be centered at 0,0 and have a radius of 1 (hence normalized). Each bezier covers no more than 90 degrees; the arc will be divided evenly into a maximum of four curves.
		_normalizedArcToBeziers = function _normalizedArcToBeziers(angleStart, angleExtent) {
			var segments = Math.ceil(Math.abs(angleExtent) / 90),
			    l = 0,
			    a = [],
			    angleIncrement,
			    controlLength,
			    angle,
			    dx,
			    dy,
			    i;
			angleStart *= _DEG2RAD;
			angleExtent *= _DEG2RAD;
			angleIncrement = angleExtent / segments;
			controlLength = 4 / 3 * Math.sin(angleIncrement / 2) / (1 + Math.cos(angleIncrement / 2));
			for (i = 0; i < segments; i++) {
				angle = angleStart + i * angleIncrement;
				dx = Math.cos(angle);
				dy = Math.sin(angle);
				a[l++] = dx - controlLength * dy;
				a[l++] = dy + controlLength * dx;
				angle += angleIncrement;
				dx = Math.cos(angle);
				dy = Math.sin(angle);
				a[l++] = dx + controlLength * dy;
				a[l++] = dy - controlLength * dx;
				a[l++] = dx;
				a[l++] = dy;
			}
			return a;
		},
	
	
		// translates SVG arc data into an array of cubic beziers
		_arcToBeziers = function _arcToBeziers(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
			if (lastX === x && lastY === y) {
				return;
			}
			rx = Math.abs(rx);
			ry = Math.abs(ry);
			var angleRad = angle % 360 * _DEG2RAD,
			    cosAngle = Math.cos(angleRad),
			    sinAngle = Math.sin(angleRad),
			    dx2 = (lastX - x) / 2,
			    dy2 = (lastY - y) / 2,
			    x1 = cosAngle * dx2 + sinAngle * dy2,
			    y1 = -sinAngle * dx2 + cosAngle * dy2,
			    rx_sq = rx * rx,
			    ry_sq = ry * ry,
			    x1_sq = x1 * x1,
			    y1_sq = y1 * y1,
			    radiiCheck = x1_sq / rx_sq + y1_sq / ry_sq;
			if (radiiCheck > 1) {
				rx = Math.sqrt(radiiCheck) * rx;
				ry = Math.sqrt(radiiCheck) * ry;
				rx_sq = rx * rx;
				ry_sq = ry * ry;
			}
			var sign = largeArcFlag === sweepFlag ? -1 : 1,
			    sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
			if (sq < 0) {
				sq = 0;
			}
			var coef = sign * Math.sqrt(sq),
			    cx1 = coef * (rx * y1 / ry),
			    cy1 = coef * -(ry * x1 / rx),
			    sx2 = (lastX + x) / 2,
			    sy2 = (lastY + y) / 2,
			    cx = sx2 + (cosAngle * cx1 - sinAngle * cy1),
			    cy = sy2 + (sinAngle * cx1 + cosAngle * cy1),
			    ux = (x1 - cx1) / rx,
			    uy = (y1 - cy1) / ry,
			    vx = (-x1 - cx1) / rx,
			    vy = (-y1 - cy1) / ry,
			    n = Math.sqrt(ux * ux + uy * uy),
			    p = ux;
			sign = uy < 0 ? -1 : 1;
			var angleStart = sign * Math.acos(p / n) * _RAD2DEG;
	
			n = Math.sqrt((ux * ux + uy * uy) * (vx * vx + vy * vy));
			p = ux * vx + uy * vy;
			sign = ux * vy - uy * vx < 0 ? -1 : 1;
			var angleExtent = sign * Math.acos(p / n) * _RAD2DEG;
			if (!sweepFlag && angleExtent > 0) {
				angleExtent -= 360;
			} else if (sweepFlag && angleExtent < 0) {
				angleExtent += 360;
			}
			angleExtent %= 360;
			angleStart %= 360;
	
			var bezierPoints = _normalizedArcToBeziers(angleStart, angleExtent),
			    a = cosAngle * rx,
			    b = sinAngle * rx,
			    c = sinAngle * -ry,
			    d = cosAngle * ry,
			    l = bezierPoints.length - 2,
			    i,
			    px,
			    py;
			//translate all the bezier points according to the matrix...
			for (i = 0; i < l; i += 2) {
				px = bezierPoints[i];
				py = bezierPoints[i + 1];
				bezierPoints[i] = px * a + py * c + cx;
				bezierPoints[i + 1] = px * b + py * d + cy;
			}
			bezierPoints[bezierPoints.length - 2] = x; //always set the end to exactly where it's supposed to be
			bezierPoints[bezierPoints.length - 1] = y;
			return bezierPoints;
		},
	
	
		//Spits back an array of cubic Bezier segments that use absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
		_pathDataToBezier = function _pathDataToBezier(d) {
			var a = (d + "").replace(_scientific, function (m) {
				var n = +m;return n < 0.0001 && n > -0.0001 ? 0 : n;
			}).match(_svgPathExp) || [],
			    //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
			path = [],
			    relativeX = 0,
			    relativeY = 0,
			    elements = a.length,
			    l = 2,
			    points = 0,
			    i,
			    j,
			    x,
			    y,
			    command,
			    isRelative,
			    segment,
			    startX,
			    startY,
			    difX,
			    difY,
			    beziers,
			    prevCommand;
			if (!d || !isNaN(a[0]) || isNaN(a[1])) {
				_log("ERROR: malformed path data: " + d);
				return path;
			}
			for (i = 0; i < elements; i++) {
				prevCommand = command;
				if (isNaN(a[i])) {
					command = a[i].toUpperCase();
					isRelative = command !== a[i]; //lower case means relative
				} else {
					//commands like "C" can be strung together without any new command characters between.
					i--;
				}
				x = +a[i + 1];
				y = +a[i + 2];
				if (isRelative) {
					x += relativeX;
					y += relativeY;
				}
				if (i === 0) {
					startX = x;
					startY = y;
				}
	
				// "M" (move)
				if (command === "M") {
					if (segment && segment.length < 8) {
						//if the path data was funky and just had a M with no actual drawing anywhere, skip it.
						path.length -= 1;
						l = 0;
					}
					relativeX = startX = x;
					relativeY = startY = y;
					segment = [x, y];
					points += l;
					l = 2;
					path.push(segment);
					i += 2;
					command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
	
					// "C" (cubic bezier)
				} else if (command === "C") {
					if (!segment) {
						segment = [0, 0];
					}
					segment[l++] = x;
					segment[l++] = y;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					segment[l++] = relativeX + a[i + 3] * 1; //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
					segment[l++] = relativeY + a[i + 4] * 1;
					segment[l++] = relativeX = relativeX + a[i + 5] * 1;
					segment[l++] = relativeY = relativeY + a[i + 6] * 1;
					//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
					//	segment.length = l = l-6;
					//}
					i += 6;
	
					// "S" (continuation of cubic bezier)
				} else if (command === "S") {
					if (prevCommand === "C" || prevCommand === "S") {
						difX = relativeX - segment[l - 4];
						difY = relativeY - segment[l - 3];
						segment[l++] = relativeX + difX;
						segment[l++] = relativeY + difY;
					} else {
						segment[l++] = relativeX;
						segment[l++] = relativeY;
					}
					segment[l++] = x;
					segment[l++] = y;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					segment[l++] = relativeX = relativeX + a[i + 3] * 1;
					segment[l++] = relativeY = relativeY + a[i + 4] * 1;
					//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
					//	segment.length = l = l-6;
					//}
					i += 4;
	
					// "Q" (quadratic bezier)
				} else if (command === "Q") {
					difX = x - relativeX;
					difY = y - relativeY;
					segment[l++] = relativeX + difX * 2 / 3;
					segment[l++] = relativeY + difY * 2 / 3;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					relativeX = relativeX + a[i + 3] * 1;
					relativeY = relativeY + a[i + 4] * 1;
					difX = x - relativeX;
					difY = y - relativeY;
					segment[l++] = relativeX + difX * 2 / 3;
					segment[l++] = relativeY + difY * 2 / 3;
					segment[l++] = relativeX;
					segment[l++] = relativeY;
	
					i += 4;
	
					// "T" (continuation of quadratic bezier)
				} else if (command === "T") {
					difX = relativeX - segment[l - 4];
					difY = relativeY - segment[l - 3];
					segment[l++] = relativeX + difX;
					segment[l++] = relativeY + difY;
					difX = relativeX + difX * 1.5 - x;
					difY = relativeY + difY * 1.5 - y;
					segment[l++] = x + difX * 2 / 3;
					segment[l++] = y + difY * 2 / 3;
					segment[l++] = relativeX = x;
					segment[l++] = relativeY = y;
	
					i += 2;
	
					// "H" (horizontal line)
				} else if (command === "H") {
					y = relativeY;
					//if (x !== relativeX) {
					segment[l++] = relativeX + (x - relativeX) / 3;
					segment[l++] = relativeY + (y - relativeY) / 3;
					segment[l++] = relativeX + (x - relativeX) * 2 / 3;
					segment[l++] = relativeY + (y - relativeY) * 2 / 3;
					segment[l++] = relativeX = x;
					segment[l++] = y;
					//}
					i += 1;
	
					// "V" (horizontal line)
				} else if (command === "V") {
					y = x; //adjust values because the first (and only one) isn't x in this case, it's y.
					x = relativeX;
					if (isRelative) {
						y += relativeY - relativeX;
					}
					//if (y !== relativeY) {
					segment[l++] = x;
					segment[l++] = relativeY + (y - relativeY) / 3;
					segment[l++] = x;
					segment[l++] = relativeY + (y - relativeY) * 2 / 3;
					segment[l++] = x;
					segment[l++] = relativeY = y;
					//}
					i += 1;
	
					// "L" (line) or "Z" (close)
				} else if (command === "L" || command === "Z") {
					if (command === "Z") {
						x = startX;
						y = startY;
						segment.closed = true;
					}
					if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
						segment[l++] = relativeX + (x - relativeX) / 3;
						segment[l++] = relativeY + (y - relativeY) / 3;
						segment[l++] = relativeX + (x - relativeX) * 2 / 3;
						segment[l++] = relativeY + (y - relativeY) * 2 / 3;
						segment[l++] = x;
						segment[l++] = y;
						if (command === "L") {
							i += 2;
						}
					}
					relativeX = x;
					relativeY = y;
	
					// "A" (arc)
				} else if (command === "A") {
					beziers = _arcToBeziers(relativeX, relativeY, a[i + 1] * 1, a[i + 2] * 1, a[i + 3] * 1, a[i + 4] * 1, a[i + 5] * 1, (isRelative ? relativeX : 0) + a[i + 6] * 1, (isRelative ? relativeY : 0) + a[i + 7] * 1);
					if (beziers) {
						for (j = 0; j < beziers.length; j++) {
							segment[l++] = beziers[j];
						}
					}
					relativeX = segment[l - 2];
					relativeY = segment[l - 1];
					i += 7;
				} else {
					_log("Error: malformed path data: " + d);
				}
			}
			path.totalPoints = points + l;
			return path;
		},
	
	
		//adds a certain number of Beziers while maintaining the path shape (so that the start/end values can have a matching quantity of points to animate). Only pass in ONE segment of the Bezier at a time. Format: [xAnchor, yAnchor, xControlPoint1, yControlPoint1, xControlPoint2, yControlPoint2, xAnchor, yAnchor, xControlPoint1, etc...]
		_subdivideBezier = function _subdivideBezier(bezier, quantity) {
			var tally = 0,
			    max = 0.999999,
			    l = bezier.length,
			    newPointsPerSegment = quantity / ((l - 2) / 6),
			    ax,
			    ay,
			    cp1x,
			    cp1y,
			    cp2x,
			    cp2y,
			    bx,
			    by,
			    x1,
			    y1,
			    x2,
			    y2,
			    i,
			    t;
			for (i = 2; i < l; i += 6) {
				tally += newPointsPerSegment;
				while (tally > max) {
					//compare with 0.99999 instead of 1 in order to prevent rounding errors
					ax = bezier[i - 2];
					ay = bezier[i - 1];
					cp1x = bezier[i];
					cp1y = bezier[i + 1];
					cp2x = bezier[i + 2];
					cp2y = bezier[i + 3];
					bx = bezier[i + 4];
					by = bezier[i + 5];
					t = 1 / (Math.floor(tally) + 1); //progress along the bezier (value between 0 and 1)
	
					x1 = ax + (cp1x - ax) * t;
					x2 = cp1x + (cp2x - cp1x) * t;
					x1 += (x2 - x1) * t;
					x2 += (cp2x + (bx - cp2x) * t - x2) * t;
	
					y1 = ay + (cp1y - ay) * t;
					y2 = cp1y + (cp2y - cp1y) * t;
					y1 += (y2 - y1) * t;
					y2 += (cp2y + (by - cp2y) * t - y2) * t;
	
					bezier.splice(i, 4, ax + (cp1x - ax) * t, //first control point
					ay + (cp1y - ay) * t, x1, //second control point
					y1, x1 + (x2 - x1) * t, //new fabricated anchor on line
					y1 + (y2 - y1) * t, x2, //third control point
					y2, cp2x + (bx - cp2x) * t, //fourth control point
					cp2y + (by - cp2y) * t);
					i += 6;
					l += 6;
					tally--;
				}
			}
			return bezier;
		},
		    _bezierToPathData = function _bezierToPathData(beziers) {
			var data = "",
			    l = beziers.length,
			    rnd = 100,
			    sl,
			    s,
			    i,
			    segment;
			for (s = 0; s < l; s++) {
				segment = beziers[s];
				data += "M" + segment[0] + "," + segment[1] + " C";
				sl = segment.length;
				for (i = 2; i < sl; i++) {
					data += (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i] * rnd | 0) / rnd + " ";
				}
				if (segment.closed) {
					data += "z";
				}
			}
			return data;
		},
		    _reverseBezier = function _reverseBezier(bezier) {
			var a = [],
			    i = bezier.length - 1,
			    l = 0;
			while (--i > -1) {
				a[l++] = bezier[i];
				a[l++] = bezier[i + 1];
				i--;
			}
			for (i = 0; i < l; i++) {
				bezier[i] = a[i];
			}
			bezier.reversed = bezier.reversed ? false : true;
		},
		    _getAverageXY = function _getAverageXY(bezier) {
			var l = bezier.length,
			    x = 0,
			    y = 0,
			    i;
			for (i = 0; i < l; i++) {
				x += bezier[i++];
				y += bezier[i];
			}
			return [x / (l / 2), y / (l / 2)];
		},
		    _getSize = function _getSize(bezier) {
			//rough estimate of the bounding box (based solely on the anchors) of a single segment. sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
			var l = bezier.length,
			    xMax = bezier[0],
			    xMin = xMax,
			    yMax = bezier[1],
			    yMin = yMax,
			    x,
			    y,
			    i;
			for (i = 6; i < l; i += 6) {
				x = bezier[i];
				y = bezier[i + 1];
				if (x > xMax) {
					xMax = x;
				} else if (x < xMin) {
					xMin = x;
				}
				if (y > yMax) {
					yMax = y;
				} else if (y < yMin) {
					yMin = y;
				}
			}
			bezier.centerX = (xMax + xMin) / 2;
			bezier.centerY = (yMax + yMin) / 2;
			return bezier.size = (xMax - xMin) * (yMax - yMin);
		},
		    _getTotalSize = function _getTotalSize(bezier) {
			//rough estimate of the bounding box of the entire list of Bezier segments (based solely on the anchors). sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
			var segment = bezier.length,
			    xMax = bezier[0][0],
			    xMin = xMax,
			    yMax = bezier[0][1],
			    yMin = yMax,
			    l,
			    x,
			    y,
			    i,
			    b;
			while (--segment > -1) {
				b = bezier[segment];
				l = b.length;
				for (i = 6; i < l; i += 6) {
					x = b[i];
					y = b[i + 1];
					if (x > xMax) {
						xMax = x;
					} else if (x < xMin) {
						xMin = x;
					}
					if (y > yMax) {
						yMax = y;
					} else if (y < yMin) {
						yMin = y;
					}
				}
			}
			bezier.centerX = (xMax + xMin) / 2;
			bezier.centerY = (yMax + yMin) / 2;
			return bezier.size = (xMax - xMin) * (yMax - yMin);
		},
		    _sortByComplexity = function _sortByComplexity(a, b) {
			return b.length - a.length;
		},
		    _sortBySize = function _sortBySize(a, b) {
			var sizeA = a.size || _getSize(a),
			    sizeB = b.size || _getSize(b);
			return Math.abs(sizeB - sizeA) < (sizeA + sizeB) / 20 ? b.centerX - a.centerX || b.centerY - a.centerY : sizeB - sizeA; //if the size is within 10% of each other, prioritize position from left to right, then top to bottom.
		},
		    _offsetBezier = function _offsetBezier(bezier, shapeIndex) {
			var a = bezier.slice(0),
			    l = bezier.length,
			    wrap = l - 2,
			    i,
			    index;
			shapeIndex = shapeIndex | 0;
			for (i = 0; i < l; i++) {
				index = (i + shapeIndex) % wrap;
				bezier[i++] = a[index];
				bezier[i] = a[index + 1];
			}
		},
		    _getTotalMovement = function _getTotalMovement(sb, eb, shapeIndex, offsetX, offsetY) {
			var l = sb.length,
			    d = 0,
			    wrap = l - 2,
			    index,
			    i,
			    x,
			    y;
			shapeIndex *= 6;
			for (i = 0; i < l; i += 6) {
				index = (i + shapeIndex) % wrap;
				y = sb[index] - (eb[i] - offsetX);
				x = sb[index + 1] - (eb[i + 1] - offsetY);
				d += Math.sqrt(x * x + y * y);
			}
			return d;
		},
		    _getClosestShapeIndex = function _getClosestShapeIndex(sb, eb, checkReverse) {
			//finds the index in a closed cubic bezier array that's closest to the angle provided (angle measured from the center or average x/y).
			var l = sb.length,
			    sCenter = _getAverageXY(sb),
			    //when comparing distances, adjust the coordinates as if the shapes are centered with each other.
			eCenter = _getAverageXY(eb),
			    offsetX = eCenter[0] - sCenter[0],
			    offsetY = eCenter[1] - sCenter[1],
			    min = _getTotalMovement(sb, eb, 0, offsetX, offsetY),
			    minIndex = 0,
			    copy,
			    d,
			    i;
			for (i = 6; i < l; i += 6) {
				d = _getTotalMovement(sb, eb, i / 6, offsetX, offsetY);
				if (d < min) {
					min = d;
					minIndex = i;
				}
			}
			if (checkReverse) {
				copy = sb.slice(0);
				_reverseBezier(copy);
				for (i = 6; i < l; i += 6) {
					d = _getTotalMovement(copy, eb, i / 6, offsetX, offsetY);
					if (d < min) {
						min = d;
						minIndex = -i;
					}
				}
			}
			return minIndex / 6;
		},
		    _getClosestAnchor = function _getClosestAnchor(bezier, x, y) {
			//finds the x/y of the anchor that's closest to the provided x/y coordinate (returns an array, like [x, y]). The bezier should be the top-level type that contains an array for each segment.
			var j = bezier.length,
			    closestDistance = 99999999999,
			    closestX = 0,
			    closestY = 0,
			    b,
			    dx,
			    dy,
			    d,
			    i,
			    l;
			while (--j > -1) {
				b = bezier[j];
				l = b.length;
				for (i = 0; i < l; i += 6) {
					dx = b[i] - x;
					dy = b[i + 1] - y;
					d = Math.sqrt(dx * dx + dy * dy);
					if (d < closestDistance) {
						closestDistance = d;
						closestX = b[i];
						closestY = b[i + 1];
					}
				}
			}
			return [closestX, closestY];
		},
		    _getClosestSegment = function _getClosestSegment(bezier, pool, startIndex, sortRatio, offsetX, offsetY) {
			//matches the bezier to the closest one in a pool (array) of beziers, assuming they are in order of size and we shouldn't drop more than 20% of the size, otherwise prioritizing location (total distance to the center). Extracts the segment out of the pool array and returns it.
			var l = pool.length,
			    index = 0,
			    minSize = Math.min(bezier.size || _getSize(bezier), pool[startIndex].size || _getSize(pool[startIndex])) * sortRatio,
			    //limit things based on a percentage of the size of either the bezier or the next element in the array, whichever is smaller.
			min = 999999999999,
			    cx = bezier.centerX + offsetX,
			    cy = bezier.centerY + offsetY,
			    size,
			    i,
			    dx,
			    dy,
			    d;
			for (i = startIndex; i < l; i++) {
				size = pool[i].size || _getSize(pool[i]);
				if (size < minSize) {
					break;
				}
				dx = pool[i].centerX - cx;
				dy = pool[i].centerY - cy;
				d = Math.sqrt(dx * dx + dy * dy);
				if (d < min) {
					index = i;
					min = d;
				}
			}
			d = pool[index];
			pool.splice(index, 1);
			return d;
		},
		    _equalizeSegmentQuantity = function _equalizeSegmentQuantity(start, end, shapeIndex, map) {
			//returns an array of shape indexes, 1 for each segment.
			var dif = end.length - start.length,
			    longer = dif > 0 ? end : start,
			    shorter = dif > 0 ? start : end,
			    added = 0,
			    sortMethod = map === "complexity" ? _sortByComplexity : _sortBySize,
			    sortRatio = map === "position" ? 0 : typeof map === "number" ? map : 0.8,
			    i = shorter.length,
			    shapeIndices = (typeof shapeIndex === "undefined" ? "undefined" : _typeof(shapeIndex)) === "object" && shapeIndex.push ? shapeIndex.slice(0) : [shapeIndex],
			    reverse = shapeIndices[0] === "reverse" || shapeIndices[0] < 0,
			    log = shapeIndex === "log",
			    eb,
			    sb,
			    b,
			    x,
			    y,
			    offsetX,
			    offsetY;
			if (!shorter[0]) {
				return;
			}
			if (longer.length > 1) {
				start.sort(sortMethod);
				end.sort(sortMethod);
				offsetX = longer.size || _getTotalSize(longer); //ensures centerX and centerY are defined (used below).
				offsetX = shorter.size || _getTotalSize(shorter);
				offsetX = longer.centerX - shorter.centerX;
				offsetY = longer.centerY - shorter.centerY;
				if (sortMethod === _sortBySize) {
					for (i = 0; i < shorter.length; i++) {
						longer.splice(i, 0, _getClosestSegment(shorter[i], longer, i, sortRatio, offsetX, offsetY));
					}
				}
			}
			if (dif) {
				if (dif < 0) {
					dif = -dif;
				}
				if (longer[0].length > shorter[0].length) {
					//since we use shorter[0] as the one to map the origination point of any brand new fabricated segments, do any subdividing first so that there are more points to choose from (if necessary)
					_subdivideBezier(shorter[0], (longer[0].length - shorter[0].length) / 6 | 0);
				}
				i = shorter.length;
				while (added < dif) {
					x = longer[i].size || _getSize(longer[i]); //just to ensure centerX and centerY are calculated which we use on the next line.
					b = _getClosestAnchor(shorter, longer[i].centerX, longer[i].centerY);
					x = b[0];
					y = b[1];
					shorter[i++] = [x, y, x, y, x, y, x, y];
					shorter.totalPoints += 8;
					added++;
				}
			}
			for (i = 0; i < start.length; i++) {
				eb = end[i];
				sb = start[i];
				dif = eb.length - sb.length;
				if (dif < 0) {
					_subdivideBezier(eb, -dif / 6 | 0);
				} else if (dif > 0) {
					_subdivideBezier(sb, dif / 6 | 0);
				}
				if (reverse && !sb.reversed) {
					_reverseBezier(sb);
				}
				shapeIndex = shapeIndices[i] || shapeIndices[i] === 0 ? shapeIndices[i] : "auto";
				if (shapeIndex) {
					//if start shape is closed, find the closest point to the start/end, and re-organize the bezier points accordingly so that the shape morphs in a more intuitive way.
					if (sb.closed || Math.abs(sb[0] - sb[sb.length - 2]) < 0.5 && Math.abs(sb[1] - sb[sb.length - 1]) < 0.5) {
						if (shapeIndex === "auto" || shapeIndex === "log") {
							shapeIndices[i] = shapeIndex = _getClosestShapeIndex(sb, eb, i === 0);
							if (shapeIndex < 0) {
								reverse = true;
								_reverseBezier(sb);
								shapeIndex = -shapeIndex;
							}
							_offsetBezier(sb, shapeIndex * 6);
						} else if (shapeIndex !== "reverse") {
							if (i && shapeIndex < 0) {
								//only happens if an array is passed as shapeIndex and a negative value is defined for an index beyond 0. Very rare, but helpful sometimes.
								_reverseBezier(sb);
							}
							_offsetBezier(sb, (shapeIndex < 0 ? -shapeIndex : shapeIndex) * 6);
						}
						//otherwise, if it's not a closed shape, consider reversing it if that would make the overall travel less
					} else if (!reverse && (shapeIndex === "auto" && Math.abs(eb[0] - sb[0]) + Math.abs(eb[1] - sb[1]) + Math.abs(eb[eb.length - 2] - sb[sb.length - 2]) + Math.abs(eb[eb.length - 1] - sb[sb.length - 1]) > Math.abs(eb[0] - sb[sb.length - 2]) + Math.abs(eb[1] - sb[sb.length - 1]) + Math.abs(eb[eb.length - 2] - sb[0]) + Math.abs(eb[eb.length - 1] - sb[1]) || shapeIndex % 2)) {
						_reverseBezier(sb);
						shapeIndices[i] = -1;
						reverse = true;
					} else if (shapeIndex === "auto") {
						shapeIndices[i] = 0;
					} else if (shapeIndex === "reverse") {
						shapeIndices[i] = -1;
					}
					if (sb.closed !== eb.closed) {
						//if one is closed and one isn't, don't close either one otherwise the tweening will look weird (but remember, the beginning and final states will honor the actual values, so this only affects the inbetween state)
						sb.closed = eb.closed = false;
					}
				}
			}
			if (log) {
				_log("shapeIndex:[" + shapeIndices.join(",") + "]");
			}
			return shapeIndices;
		},
		    _pathFilter = function _pathFilter(a, shapeIndex, map, precompile) {
			var start = _pathDataToBezier(a[0]),
			    end = _pathDataToBezier(a[1]);
			if (!_equalizeSegmentQuantity(start, end, shapeIndex || shapeIndex === 0 ? shapeIndex : "auto", map)) {
				return; //malformed path data or null target
			}
			a[0] = _bezierToPathData(start);
			a[1] = _bezierToPathData(end);
			if (precompile === "log" || precompile === true) {
				_log('precompile:["' + a[0] + '","' + a[1] + '"]');
			}
		},
		    _buildPathFilter = function _buildPathFilter(shapeIndex, map, precompile) {
			return map || precompile || shapeIndex || shapeIndex === 0 ? function (a) {
				_pathFilter(a, shapeIndex, map, precompile);
			} : _pathFilter;
		},
		    _offsetPoints = function _offsetPoints(text, offset) {
			if (!offset) {
				return text;
			}
			var a = text.match(_numbersExp) || [],
			    l = a.length,
			    s = "",
			    inc,
			    i,
			    j;
			if (offset === "reverse") {
				i = l - 1;
				inc = -2;
			} else {
				i = ((parseInt(offset, 10) || 0) * 2 + 1 + l * 100) % l;
				inc = 2;
			}
			for (j = 0; j < l; j += 2) {
				s += a[i - 1] + "," + a[i] + " ";
				i = (i + inc) % l;
			}
			return s;
		},
	
		//adds a certain number of points while maintaining the polygon/polyline shape (so that the start/end values can have a matching quantity of points to animate). Returns the revised string.
		_equalizePointQuantity = function _equalizePointQuantity(a, quantity) {
			var tally = 0,
			    x = parseFloat(a[0]),
			    y = parseFloat(a[1]),
			    s = x + "," + y + " ",
			    max = 0.999999,
			    newPointsPerSegment,
			    i,
			    l,
			    j,
			    factor,
			    nextX,
			    nextY;
			l = a.length;
			newPointsPerSegment = quantity * 0.5 / (l * 0.5 - 1);
			for (i = 0; i < l - 2; i += 2) {
				tally += newPointsPerSegment;
				nextX = parseFloat(a[i + 2]);
				nextY = parseFloat(a[i + 3]);
				if (tally > max) {
					//compare with 0.99999 instead of 1 in order to prevent rounding errors
					factor = 1 / (Math.floor(tally) + 1);
					j = 1;
					while (tally > max) {
						s += (x + (nextX - x) * factor * j).toFixed(2) + "," + (y + (nextY - y) * factor * j).toFixed(2) + " ";
						tally--;
						j++;
					}
				}
				s += nextX + "," + nextY + " ";
				x = nextX;
				y = nextY;
			}
			return s;
		},
		    _pointsFilter = function _pointsFilter(a) {
			var startNums = a[0].match(_numbersExp) || [],
			    endNums = a[1].match(_numbersExp) || [],
			    dif = endNums.length - startNums.length;
			if (dif > 0) {
				a[0] = _equalizePointQuantity(startNums, dif);
			} else {
				a[1] = _equalizePointQuantity(endNums, -dif);
			}
		},
		    _buildPointsFilter = function _buildPointsFilter(shapeIndex) {
			return !isNaN(shapeIndex) ? function (a) {
				_pointsFilter(a);
				a[1] = _offsetPoints(a[1], parseInt(shapeIndex, 10));
			} : _pointsFilter;
		},
		    _createPath = function _createPath(e, ignore) {
			var path = _gsScope.document.createElementNS("http://www.w3.org/2000/svg", "path"),
			    attr = Array.prototype.slice.call(e.attributes),
			    i = attr.length,
			    name;
			ignore = "," + ignore + ",";
			while (--i > -1) {
				name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
				if (ignore.indexOf("," + name + ",") === -1) {
					path.setAttributeNS(null, name, attr[i].nodeValue);
				}
			}
			return path;
		},
		    _convertToPath = function _convertToPath(e, swap) {
			var type = e.tagName.toLowerCase(),
			    circ = 0.552284749831,
			    data,
			    x,
			    y,
			    r,
			    ry,
			    path,
			    rcirc,
			    rycirc,
			    points,
			    w,
			    h,
			    x2,
			    x3,
			    x4,
			    x5,
			    x6,
			    y2,
			    y3,
			    y4,
			    y5,
			    y6;
			if (type === "path" || !e.getBBox) {
				return e;
			}
			path = _createPath(e, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
			if (type === "rect") {
				r = +e.getAttribute("rx") || 0;
				ry = +e.getAttribute("ry") || 0;
				x = +e.getAttribute("x") || 0;
				y = +e.getAttribute("y") || 0;
				w = (+e.getAttribute("width") || 0) - r * 2;
				h = (+e.getAttribute("height") || 0) - ry * 2;
				if (r || ry) {
					//if there are rounded corners, render cubic beziers
					x2 = x + r * (1 - circ);
					x3 = x + r;
					x4 = x3 + w;
					x5 = x4 + r * circ;
					x6 = x4 + r;
					y2 = y + ry * (1 - circ);
					y3 = y + ry;
					y4 = y3 + h;
					y5 = y4 + ry * circ;
					y6 = y4 + ry;
					data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [x6, y5, x5, y6, x4, y6, x4 - (x4 - x3) / 3, y6, x3 + (x4 - x3) / 3, y6, x3, y6, x2, y6, x, y5, x, y4, x, y4 - (y4 - y3) / 3, x, y3 + (y4 - y3) / 3, x, y3, x, y2, x2, y, x3, y, x3 + (x4 - x3) / 3, y, x4 - (x4 - x3) / 3, y, x4, y, x5, y, x6, y2, x6, y3].join(",") + "z";
				} else {
					data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
				}
			} else if (type === "circle" || type === "ellipse") {
				if (type === "circle") {
					r = ry = +e.getAttribute("r") || 0;
					rycirc = r * circ;
				} else {
					r = +e.getAttribute("rx") || 0;
					ry = +e.getAttribute("ry") || 0;
					rycirc = ry * circ;
				}
				x = +e.getAttribute("cx") || 0;
				y = +e.getAttribute("cy") || 0;
				rcirc = r * circ;
				data = "M" + (x + r) + "," + y + " C" + [x + r, y + rycirc, x + rcirc, y + ry, x, y + ry, x - rcirc, y + ry, x - r, y + rycirc, x - r, y, x - r, y - rycirc, x - rcirc, y - ry, x, y - ry, x + rcirc, y - ry, x + r, y - rycirc, x + r, y].join(",") + "z";
			} else if (type === "line") {
				data = _bezierToPathData(_pathDataToBezier("M" + (e.getAttribute("x1") || 0) + "," + (e.getAttribute("y1") || 0) + " L" + (e.getAttribute("x2") || 0) + "," + (e.getAttribute("y2") || 0))); //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
			} else if (type === "polyline" || type === "polygon") {
				points = (e.getAttribute("points") + "").match(_numbersExp) || [];
				x = points.shift();
				y = points.shift();
				data = "M" + x + "," + y + " L" + points.join(",");
				if (type === "polygon") {
					data += "," + x + "," + y + "z";
				}
			}
			path.setAttribute("d", data);
			if (swap && e.parentNode) {
				e.parentNode.insertBefore(path, e);
				e.parentNode.removeChild(e);
			}
	
			return path;
		},
		    _parseShape = function _parseShape(shape, forcePath, target) {
			var isString = typeof shape === "string",
			    e,
			    type;
			if (!isString || _selectorExp.test(shape) || (shape.match(_numbersExp) || []).length < 3) {
				e = isString ? TweenLite.selector(shape) : shape && shape[0] ? shape : [shape]; //allow array-like objects like jQuery objects.
				if (e && e[0]) {
					e = e[0];
					type = e.nodeName.toUpperCase();
					if (forcePath && type !== "PATH") {
						//if we were passed an element (or selector text for an element) that isn't a path, convert it.
						e = _convertToPath(e, false);
						type = "PATH";
					}
					shape = e.getAttribute(type === "PATH" ? "d" : "points") || "";
					if (e === target) {
						//if the shape matches the target element, the user wants to revert to the original which should have been stored in the data-original attribute
						shape = e.getAttributeNS(null, "data-original") || shape;
					}
				} else {
					_log("WARNING: invalid morph to: " + shape);
					shape = false;
				}
			}
			return shape;
		},
		    _morphMessage = "Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.",
		    MorphSVGPlugin = _gsScope._gsDefine.plugin({
			propName: "morphSVG",
			API: 2,
			global: true,
			version: "0.8.11",
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function init(target, value, tween, index) {
				var type, p, pt, shape, isPoly;
				if (typeof target.setAttribute !== "function") {
					return false;
				}
				if (typeof value === "function") {
					value = value(index, target);
				}
				type = target.nodeName.toUpperCase();
				isPoly = type === "POLYLINE" || type === "POLYGON";
				if (type !== "PATH" && !isPoly) {
					_log("WARNING: cannot morph a <" + type + "> SVG element. " + _morphMessage);
					return false;
				}
				p = type === "PATH" ? "d" : "points";
				if (typeof value === "string" || value.getBBox || value[0]) {
					value = { shape: value };
				}
				shape = _parseShape(value.shape || value.d || value.points || "", p === "d", target);
				if (isPoly && _commands.test(shape)) {
					_log("WARNING: a <" + type + "> cannot accept path data. " + _morphMessage);
					return false;
				}
				if (shape) {
					this._target = target;
					if (!target.getAttributeNS(null, "data-original")) {
						target.setAttributeNS(null, "data-original", target.getAttribute(p)); //record the original state in a data-original attribute so that we can revert to it later.
					}
					pt = this._addTween(target, "setAttribute", target.getAttribute(p) + "", shape + "", "morphSVG", false, p, _typeof(value.precompile) === "object" ? function (a) {
						a[0] = value.precompile[0];a[1] = value.precompile[1];
					} : p === "d" ? _buildPathFilter(value.shapeIndex, value.map || MorphSVGPlugin.defaultMap, value.precompile) : _buildPointsFilter(value.shapeIndex));
					if (pt) {
						this._overwriteProps.push("morphSVG");
						pt.end = shape;
						pt.endProp = p;
					}
				}
				return true;
			},
	
			set: function set(ratio) {
				var pt;
				this._super.setRatio.call(this, ratio);
				if (ratio === 1) {
					pt = this._firstPT;
					while (pt) {
						if (pt.end) {
							this._target.setAttribute(pt.endProp, pt.end); //make sure the end value is exactly as specified (in case we had to add fabricated points during the tween)
						}
						pt = pt._next;
					}
				}
			}
	
		});
	
		MorphSVGPlugin.pathFilter = _pathFilter;
		MorphSVGPlugin.pointsFilter = _pointsFilter;
		MorphSVGPlugin.subdivideRawBezier = _subdivideBezier;
		MorphSVGPlugin.defaultMap = "size";
		MorphSVGPlugin.pathDataToRawBezier = function (data) {
			return _pathDataToBezier(_parseShape(data, true));
		};
		MorphSVGPlugin.equalizeSegmentQuantity = _equalizeSegmentQuantity;
	
		MorphSVGPlugin.convertToPath = function (targets, swap) {
			if (typeof targets === "string") {
				targets = TweenLite.selector(targets);
			}
			var a = !targets || targets.length === 0 ? [] : targets.length && targets[0] && targets[0].nodeType ? Array.prototype.slice.call(targets, 0) : [targets],
			    i = a.length;
			while (--i > -1) {
				a[i] = _convertToPath(a[i], swap !== false);
			}
			return a;
		};
	
		MorphSVGPlugin.pathDataToBezier = function (data, vars) {
			//converts SVG path data into an array of {x, y} objects that can be plugged directly into a bezier tween. You can optionally pass in a 2D matrix like [a, b, c, d, tx, ty] containing numbers that should transform each point.
			var bezier = _pathDataToBezier(_parseShape(data, true))[0] || [],
			    prefix = 0,
			    a,
			    i,
			    l,
			    matrix,
			    offsetX,
			    offsetY,
			    bbox,
			    e;
			vars = vars || {};
			e = vars.align || vars.relative;
			matrix = vars.matrix || [1, 0, 0, 1, 0, 0];
			offsetX = vars.offsetX || 0;
			offsetY = vars.offsetY || 0;
			if (e === "relative" || e === true) {
				offsetX -= bezier[0] * matrix[0] + bezier[1] * matrix[2];
				offsetY -= bezier[0] * matrix[1] + bezier[1] * matrix[3];
				prefix = "+=";
			} else {
				offsetX += matrix[4];
				offsetY += matrix[5];
				if (e) {
					e = typeof e === "string" ? TweenLite.selector(e) : e && e[0] ? e : [e]; //allow array-like objects like jQuery objects.
					if (e && e[0]) {
						bbox = e[0].getBBox() || { x: 0, y: 0 };
						offsetX -= bbox.x;
						offsetY -= bbox.y;
					}
				}
			}
			a = [];
			l = bezier.length;
			if (matrix && matrix.join(",") !== "1,0,0,1,0,0") {
				for (i = 0; i < l; i += 2) {
					a.push({ x: prefix + (bezier[i] * matrix[0] + bezier[i + 1] * matrix[2] + offsetX), y: prefix + (bezier[i] * matrix[1] + bezier[i + 1] * matrix[3] + offsetY) });
				}
			} else {
				for (i = 0; i < l; i += 2) {
					a.push({ x: prefix + (bezier[i] + offsetX), y: prefix + (bezier[i + 1] + offsetY) });
				}
			}
			return a;
		};
	});if (_gsScope._gsDefine) {
		_gsScope._gsQueue.pop()();
	}
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function (name) {
		"use strict";
	
		var getGlobal = function getGlobal() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof module !== "undefined" && module.exports) {
			//node
			__webpack_require__(16);
			module.exports = getGlobal();
		} else if (true) {
			//AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	})("MorphSVGPlugin");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SwipeListener = function SwipeListener(element, options) {
	  if (!element) return;
	
	  // CustomEvent polyfill
	  if (typeof window !== 'undefined') {
	    (function () {
	      if (typeof window.CustomEvent === 'function') return false;
	      function CustomEvent(event, params) {
	        params = params || {
	          bubbles: false,
	          cancelable: false,
	          detail: undefined
	        };
	        var evt = document.createEvent('CustomEvent');
	        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	        return evt;
	      }
	      CustomEvent.prototype = window.Event.prototype;
	      window.CustomEvent = CustomEvent;
	    })();
	  }
	
	  var defaultOpts = {
	    minHorizontal: 10, // Minimum number of pixels traveled to count as a horizontal swipe.
	    minVertical: 10, // Minimum number of pixels traveled to count as a vertical swipe.
	    deltaHorizontal: 3, // Delta for horizontal swipe
	    deltaVertical: 5, // Delta for vertical swipe
	    preventScroll: false, // Prevents scrolling when swiping.
	    lockAxis: true // Select only one axis to be true instead of multiple.
	  };
	
	  // Set options
	  if (!options) {
	    options = {};
	  }
	  options = _extends({}, defaultOpts, options);
	
	  // Store the touches
	  var touches = [];
	
	  // Not dragging by default.
	  var dragging = false;
	
	  // When mouse-click is started, make dragging true.
	  var _mousedown = function _mousedown(e) {
	    dragging = true;
	  };
	  element.addEventListener('mousedown', _mousedown);
	
	  // When mouse-click is released, make dragging false and signify end by imitating `touchend`.
	  var _mouseup = function _mouseup(e) {
	    dragging = false;
	    _touchend(e);
	  };
	  element.addEventListener('mouseup', _mouseup);
	
	  // When mouse is moved while being clicked, imitate a `touchmove`.
	  var _mousemove = function _mousemove(e) {
	    if (dragging) {
	      e.changedTouches = [{
	        clientX: e.clientX,
	        clientY: e.clientY
	      }];
	      _touchmove(e);
	    }
	  };
	  element.addEventListener('mousemove', _mousemove);
	
	  // When the swipe is completed, calculate the direction.
	  var _touchend = function _touchend(e) {
	    if (!touches.length) return;
	
	    var x = [],
	        y = [];
	
	    var directions = {
	      top: false,
	      right: false,
	      bottom: false,
	      left: false
	    };
	
	    for (var i = 0; i < touches.length; i++) {
	      x.push(touches[i].x);
	      y.push(touches[i].y);
	    }
	
	    var xs = x[0],
	        xe = x[x.length - 1],
	        // Start and end x-coords
	    ys = y[0],
	        ye = y[y.length - 1]; // Start and end y-coords
	
	    var eventCoords = {
	      x: [xs, xe],
	      y: [ys, ye]
	    };
	
	    if (touches.length > 1) {
	      var swipeReleaseEventData = {
	        detail: eventCoords
	      };
	
	      var swipeReleaseEvent = new CustomEvent('swiperelease', swipeReleaseEventData);
	      element.dispatchEvent(swipeReleaseEvent);
	    }
	
	    // Determine left or right
	    var diff = x[0] - x[x.length - 1];
	    var swipe = 'none';
	    if (diff > 0) {
	      swipe = 'left';
	    } else {
	      swipe = 'right';
	    }
	
	    var min = Math.min.apply(Math, x),
	        max = Math.max.apply(Math, x),
	        _diff = void 0;
	
	    // If minimum horizontal distance was travelled
	    if (Math.abs(diff) >= options.minHorizontal) {
	      switch (swipe) {
	        case 'left':
	          _diff = Math.abs(min - x[x.length - 1]);
	          if (_diff <= options.deltaHorizontal) {
	            directions.left = true;
	          }
	          break;
	        case 'right':
	          _diff = Math.abs(max - x[x.length - 1]);
	          if (_diff <= options.deltaHorizontal) {
	            directions.right = true;
	          }
	          break;
	      }
	    }
	
	    // Determine top or bottom
	    diff = y[0] - y[y.length - 1];
	    swipe = 'none';
	    if (diff > 0) {
	      swipe = 'top';
	    } else {
	      swipe = 'bottom';
	    }
	
	    min = Math.min.apply(Math, y);
	    max = Math.max.apply(Math, y);
	
	    // If minimum vertical distance was travelled
	    if (Math.abs(diff) >= options.minVertical) {
	      switch (swipe) {
	        case 'top':
	          _diff = Math.abs(min - y[y.length - 1]);
	          if (_diff <= options.deltaVertical) {
	            directions.top = true;
	          }
	          break;
	        case 'bottom':
	          _diff = Math.abs(max - y[y.length - 1]);
	          if (_diff <= options.deltaVertical) {
	            directions.bottom = true;
	          }
	          break;
	      }
	    }
	
	    // Clear touches array.
	    touches = [];
	
	    // If there is a swipe direction, emit an event.
	    if (directions.top || directions.right || directions.bottom || directions.left) {
	      /**
	       * If lockAxis is true, determine which axis to select.
	       * The axis with the most travel is selected.
	       * TODO: Factor in for the orientation of the device
	       * and use it as a weight to determine the travel along an axis.
	       */
	      if (options.lockAxis) {
	        if ((directions.left || directions.right) && Math.abs(xs - xe) > Math.abs(ys - ye)) {
	          directions.top = directions.bottom = false;
	        } else if ((directions.top || directions.bottom) && Math.abs(xs - xe) < Math.abs(ys - ye)) {
	          directions.left = directions.right = false;
	        }
	      }
	
	      var eventData = {
	        detail: _extends({
	          directions: directions
	        }, eventCoords)
	      };
	
	      var event = new CustomEvent('swipe', eventData);
	      element.dispatchEvent(event);
	    } else {
	      var cancelEvent = new CustomEvent('swipecancel', {
	        detail: eventCoords
	      });
	      element.dispatchEvent(cancelEvent);
	    }
	  };
	
	  // When a swipe is performed, store the coords.
	  var _touchmove = function _touchmove(e) {
	    if (options.preventScroll) {
	      e.preventDefault();
	    }
	    var touch = e.changedTouches[0];
	    touches.push({
	      x: touch.clientX,
	      y: touch.clientY
	    });
	
	    // Emit a `swiping` event if there are more than one touch-points.
	    if (touches.length > 1) {
	      var xs = touches[0].x,
	          // Start and end x-coords
	      xe = touches[touches.length - 1].x,
	          ys = touches[0].y,
	          // Start and end y-coords
	      ye = touches[touches.length - 1].y,
	          eventData = {
	        detail: {
	          x: [xs, xe],
	          y: [ys, ye]
	        }
	      };
	      var event = new CustomEvent('swiping', eventData);
	      element.dispatchEvent(event);
	    }
	  };
	
	  // Test via a getter in the options object to see if the passive property is accessed
	  var passiveOptions = false;
	  try {
	    var testOptions = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveOptions = { passive: !options.preventScroll };
	      }
	    });
	    window.addEventListener('testPassive', null, testOptions);
	    window.removeEventListener('testPassive', null, testOptions);
	  } catch (e) {}
	
	  element.addEventListener('touchmove', _touchmove, passiveOptions);
	  element.addEventListener('touchend', _touchend);
	
	  return {
	    off: function off() {
	      element.removeEventListener('touchmove', _touchmove, passiveOptions);
	      element.removeEventListener('touchend', _touchend);
	      element.removeEventListener('mousedown', _mousedown);
	      element.removeEventListener('mouseup', _mouseup);
	      element.removeEventListener('mousemove', _mousemove);
	    }
	  };
	};
	
	module.exports = SwipeListener;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.homeQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(55);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HeroContainer = __webpack_require__(557);
	
	var _HeroContainer2 = _interopRequireDefault(_HeroContainer);
	
	var _Carousel = __webpack_require__(555);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_Component) {
	  _inherits(Homepage, _Component);
	
	  function Homepage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Homepage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      revealText: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Homepage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ revealText: true });
	    }, 500);
	    this.props.resetDisplaySettings();
	  };
	
	  Homepage.prototype.render = function render() {
	    // hardcoding order
	    var slideData = [this.props.data.homeSlides.edges.find(function (data) {
	      return data.node.post_type === 'exhibition';
	    }), this.props.data.homeSlides.edges.find(function (data) {
	      return data.node.post_type === 'timeline';
	    }), this.props.data.homeSlides.edges.find(function (data) {
	      return data.node.post_type === 'tour';
	    })].concat(this.props.data.otherSlides.edges);
	    return _react2.default.createElement(
	      _HeroContainer2.default,
	      {
	        top: true,
	        exiting: this.props.transition && this.props.transition.status === 'exiting'
	      },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'The House on Henry Street' }),
	      _react2.default.createElement(_Carousel2.default, {
	        introIsShowing: this.props.introIsShowing,
	        slideData: slideData,
	        revealText: this.state.revealText
	      })
	    );
	  };
	
	  return Homepage;
	}(_react.Component);
	
	exports.default = Homepage;
	var homeQuery = exports.homeQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4bb104d5c0dfefa71170.js